(function () {
  const mobileBreakpoint = 1024;
  const accordionWrapperClass = 'js-mobile-accordion-wrapper';
  const accordionClass = 'js-mobile-accordion';
  const accordionHeaderClass = 'js-accordion-header';
  const chevronClass = 'js-accordion-chevron';

  function isMobile() {
    return window.innerWidth < mobileBreakpoint;
  }

  function createChevron() {
    const span = document.createElement('span');
    span.className = chevronClass;
    span.innerHTML = `
      <svg
        width="12"
        height="12"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/>
      </svg>
    `;
    span.style.transition = 'transform 0.3s ease';
    span.style.marginLeft = '8px';
    return span;
  }

  function createAccordionHeader(title) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = accordionHeaderClass;
    button.style.display = 'flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'space-between';
    button.style.width = '100%';
    button.style.cursor = 'pointer';
    button.style.background = 'none';
    button.style.border = '0';
    button.style.padding = '0';

    const titleSpan = document.createElement('span');
    titleSpan.textContent = title;

    const chevron = createChevron();

    button.appendChild(titleSpan);
    button.appendChild(chevron);

    return button;
  }

  function enableAccordions() {
    document.querySelectorAll('ul.collapse-on-mobile').forEach((ul) => {
      if (ul.classList.contains(accordionClass)) return;

      const title = ul.dataset.linklistTitle;
      if (!title) return;

      const wrapper = document.createElement('div');
      wrapper.className = accordionWrapperClass;

      const header = createAccordionHeader(title);

      ul.classList.add(accordionClass);
      ul.style.display = 'none';

      ul.parentNode.insertBefore(wrapper, ul);
      wrapper.appendChild(header);
      wrapper.appendChild(ul);
    });
  }

  function disableAccordions() {
    document.querySelectorAll(`.${accordionWrapperClass}`).forEach((wrapper) => {
      const ul = wrapper.querySelector(`ul.${accordionClass}`);
      if (!ul) return;

      ul.classList.remove(accordionClass);
      ul.style.display = '';

      wrapper.parentNode.insertBefore(ul, wrapper);
      wrapper.remove();
    });
  }

  document.addEventListener('click', function (event) {
    if (!isMobile()) return;

    const header = event.target.closest(`.${accordionHeaderClass}`);
    if (!header) return;

    const wrapper = header.closest(`.${accordionWrapperClass}`);
    if (!wrapper) return;

    const ul = wrapper.querySelector(`ul.${accordionClass}`);
    if (!ul) return;

    const chevron = header.querySelector(`.${chevronClass}`);
    const isOpen = ul.style.display === 'block';

    ul.style.display = isOpen ? 'none' : 'block';

    if (chevron) {
      chevron.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    }
  });

  function handleResize() {
    if (isMobile()) {
      enableAccordions();
    } else {
      disableAccordions();
    }
  }

  window.addEventListener('resize', handleResize);
  document.addEventListener('DOMContentLoaded', handleResize);
})();
